module.exports = __webpack_public_path__ + "img/cel-web.3887b962.webp";